import { withLoader } from 'util/routeHelper';

export default store => ({
	path: 'coliving',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'coliving',
				),
			store,
			'COLIVING',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/Coliving/index.js